import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

const BatchInsights = () => {
    const privileges = secureLocalStorage.getItem("privileges");
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();

    const initialEntries = Number(searchParams.get("entries")) || 10;
    const initialPage = Number(searchParams.get("page")) || 1;
    const { useFetch } = useAPIQuery({
        key: "requierement-analysis",
        endpoint: "/api/batch-view/",
    });

    const [entries, setEntries] = useState(initialEntries);
    const [pageIndex, setPageIndex] = useState(initialPage - 1);
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [columnFilterKey, setColumnFilterKey] = useState("");
    const [columnFilterValue, setColumnFilterValue] = useState("");

    const requirementData = useFetch({
        params: {
            entries: entries,
            page_no: pageIndex + 1,
            q: globalFilterValue !== "" ? globalFilterValue : columnFilterValue,
            c: globalFilterValue === "" ? columnFilterKey : "",
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: true,
        staleTime: 300000,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const columnsRM = [
        {
            accessor: "batch_number",
            header: "Batch Number",
            filterable: true,
        },
        {
            accessor: "item",
            header: "Item Name",
            filterable: privileges.includes("search_item_batch_insights")
                ? true
                : false,
        },
        privileges.includes("batch_insights_detail") && {
            accessor: "batch_insights",
            header: "Details",
            cell: (row) => (
                <button
                    className="btn btn-sm btn-primary"
                    onClick={() =>
                        navigate("/batch-insights-detail", {
                            state: { data: row },
                        })
                    }
                >
                    View
                </button>
            ),
        },
    ].filter(Boolean);

    const handleGlobalFilterChange = (value) => {
        console.log(value);
        setGlobalFilterValue(value);
    };
    const handleColumnFilterChange = (value) => {
        console.log(value);
        setColumnFilterKey(
            value
                .filter((item) => item.value)
                .map((item) => item.id)
                .join(",")
        );
        setColumnFilterValue(
            value
                .filter((item) => item.value)
                .map((item) => item.value)
                .join(",")
        );
    };

    const handlePagination = (value) => {
        console.log(value);
        setSearchParams({
            entries: value.pageSize,
            page: value.pageIndex + 1,
        });
        setPageIndex(value.pageIndex);
        setEntries(value.pageSize);
    };

    return (
        <div>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">
                            Batch Insights
                        </h3>
                    </div>
                </div>
            </div>
            <Table
                data={
                    requirementData?.data?.results?.data?.length > 0
                        ? requirementData?.data?.results?.data
                        : []
                }
                columns={columnsRM}
                isLoading={
                    requirementData.isLoading || requirementData.isFetching
                }
                onColumnFilterChange={handleColumnFilterChange}
                pagination
                pageIndex={pageIndex}
                pageSize={entries}
                rowCount={requirementData ? requirementData?.data?.count : 0}
                selectRows={false}
                globalSearch={false}
                filterModal={false}
                editRows={false}
                deleteRows={false}
                onPaginationChange={handlePagination}
                onGlobalFilterChange={handleGlobalFilterChange}
            />
        </div>
    );
};

export default BatchInsights;
